import settingDrawer from './it-IT/settingDrawer';
export default Object.assign({}, settingDrawer);